
import {map} from 'rxjs/operators';

import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { GenericPagingVM } from '../models/index';
import { CounsellorSearchRequestVM } from '../models/CounsellorSearchRequestVM';
import { Observable ,  Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class SearchService extends BaseService {

    results: any[];
    paging: GenericPagingVM;
    searchRequest: CounsellorSearchRequestVM;

    constructor(private http: HttpClient) {
        super();
    }

    public initSearch(request: CounsellorSearchRequestVM): Observable<boolean> {
        this.results = [];
        this.searchRequest = request;
        this.paging = new GenericPagingVM();

        var subject = new Subject<boolean>();
        this.http.post('/api/counsellor/search', request, this.getHttpOptions(true)).pipe(
            map(resp => resp as GenericPagingVM))
            .subscribe(returnValue => {
                this.paging = returnValue;
                this.results = returnValue.items;
                subject.next(true);
            },
            error => {
                subject.next(false);
            }
        );

        return subject.asObservable();
    }

    public hasMoreResults(): boolean {
        return (this.paging.nextPagingToken != null);
    }

    public loadMoreResults(): Observable<boolean> {
        var subject = new Subject<boolean>();
        this.searchRequest.continuationToken = this.paging.nextPagingToken;
        this.http.post('/api/counsellor/search', this.searchRequest, this.getHttpOptions(true)).pipe(
            map(resp => resp as GenericPagingVM))
            .subscribe(returnValue => {
                this.cacheResults(returnValue);
                subject.next(true);
            },
            error => {
                subject.next(false);
            }
            );

        return subject.asObservable();
    }

    public cacheResults(pagingResponse: GenericPagingVM) {
        this.results = this.results.concat(pagingResponse.items);
        this.paging = pagingResponse;
    }

}
